import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'thermia-react-container';

interface Props {
  handleCancel: () => void;
}

const CompleteSuccess: FC<Props> = ({ handleCancel }) => {
  const { t } = useTranslation('registrations');
  const navigate = useNavigate();
  const handleClick = () => {
    handleCancel();
    navigate('/registrations');
  };

  return (
    <>
      <DialogTitle>{t('registrations.general.completeRegistrationSuccess')}</DialogTitle>
      <DialogContent>{t('registrations.general.completeRegistrationSuccess')}</DialogContent>
      <DialogActions>
        <Button title={t('registrations.general.ok')} variant={'contained'} onClick={handleClick} />
      </DialogActions>
    </>
  );
};

export default CompleteSuccess;
